import { render, staticRenderFns } from "./Reader.vue?vue&type=template&id=6ca9debf&scoped=true"
import script from "./Reader.vue?vue&type=script&lang=js"
export * from "./Reader.vue?vue&type=script&lang=js"
import style0 from "./Reader.vue?vue&type=style&index=0&id=6ca9debf&prod&lang=scss&scoped=true"
import style1 from "./Reader.vue?vue&type=style&index=1&id=6ca9debf&prod&lang=scss&scoped=true"
import style2 from "./Reader.vue?vue&type=style&index=2&id=6ca9debf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca9debf",
  null
  
)

export default component.exports